module.exports = __webpack_public_path__ + "b9c179cc474f5fcfa423850162646d2f.svg";